import { useEffect, useState } from "react";

type GuideStep = {
  id: number;
  label: string;
  title: string;
  body: string;
  image: string;
};

const STEPS: GuideStep[] = [
  {
    id: 1,
    label: "STEP 01",
    title: "회원가입 및 본인인증",
    body: "가입 후 본인확인 절차를 완료하면 결제 등록을 시작할 수 있습니다.",
    image: "/kailospay/가입.png",
  },
  {
    id: 2,
    label: "STEP 02",
    title: "결제 등록 정보 입력",
    body: "주류 거래 정보를 입력하고 상대방 정보를 정확히 기입합니다.",
    image: "/kailospay/결제등록1.png",
  },
  {
    id: 3,
    label: "STEP 03",
    title: "결제 유형 선택",
    body: "상황에 맞는 결제 유형을 선택하고 필요한 서류를 등록합니다.",
    image: "/kailospay/결제등록2.png",
  },
  {
    id: 4,
    label: "STEP 04",
    title: "결제 진행 및 완료",
    body: "결제 링크를 통해 카드 결제를 진행하고 상태를 확인합니다.",
    image: "/kailospay/결제화면.png",
  },
];

const AUTO_MS = 3500;

export default function GuideIntro() {
  const [activeIdx, setActiveIdx] = useState(0);
  const current = STEPS[activeIdx] || STEPS[0];

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveIdx((prev) => (prev + 1) % STEPS.length);
    }, AUTO_MS);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="min-h-[100dvh] bg-[#fff4ea] pb-16">
      <div className="mx-auto max-w-6xl px-4 py-4 sm:px-6 lg:px-10">
        <section className="relative overflow-hidden rounded-[28px] border border-[#ffd9bb] bg-[#fff8f2] shadow-[0_20px_60px_rgba(120,53,15,0.12)]">
          <div
            className="pointer-events-none absolute inset-0"
            style={{
              background:
                "radial-gradient(circle at 12% 18%, rgba(251,146,60,0.20), transparent 45%), radial-gradient(circle at 86% 80%, rgba(249,115,22,0.14), transparent 38%)",
            }}
          />

          <div className="relative grid grid-cols-1 gap-8 p-6 md:grid-cols-2 md:gap-10 md:p-10 lg:p-12">
            <div className="flex flex-col justify-center">
              <h1 className="text-3xl font-black tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
                주류페이 이용방법
              </h1>

              <div className="mt-6 flex flex-wrap items-center gap-3">
                <a
                  href="/contracts/new?type=drink"
                  className="inline-flex items-center justify-center rounded-full bg-orange-500 px-5 py-2.5 text-sm font-semibold text-white shadow-[0_8px_20px_rgba(249,115,22,0.35)] transition hover:bg-orange-400"
                >
                  결제등록 시작
                </a>
                <a
                  href="/faq"
                  className="inline-flex items-center justify-center rounded-full border border-orange-200 bg-white px-5 py-2.5 text-sm font-semibold text-orange-700 transition hover:bg-orange-50"
                >
                  FAQ 바로가기
                </a>
              </div>

              <div className="mt-6 rounded-2xl border border-orange-100 bg-white/95 p-4 shadow-sm sm:p-5">
                <div className="text-xs font-bold tracking-[0.2em] text-orange-600">
                  {current.label}
                </div>
                <div className="mt-2 text-2xl font-black text-slate-900">
                  {current.title}
                </div>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{current.body}</p>
              </div>
            </div>

            <div className="mx-auto flex w-full max-w-[332px] flex-col items-center justify-center sm:max-w-[346px]">
              <div className="w-full rounded-[38px] border-[10px] border-slate-900 bg-slate-900 p-1.5 shadow-[0_16px_50px_rgba(2,6,23,0.35)]">
                <div className="relative overflow-hidden rounded-[28px] bg-[#eef2f7] aspect-[1179/2556]">
                  <div className="absolute left-1/2 top-2 z-10 h-1.5 w-24 -translate-x-1/2 rounded-full bg-slate-800/80" />
                  <img
                    src={current.image}
                    alt={current.title}
                    className="absolute inset-0 block h-full w-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="mt-4 flex items-center gap-2 rounded-full bg-white/85 px-3 py-2 shadow-sm">
                {STEPS.map((step, idx) => {
                  const active = idx === activeIdx;
                  return (
                    <button
                      key={step.id}
                      type="button"
                      onClick={() => setActiveIdx(idx)}
                      aria-label={`${step.label} 보기`}
                      className={[
                        "transition",
                        active
                          ? "h-3 w-8 rounded-full bg-slate-900"
                          : "h-3 w-3 rounded-full bg-slate-300 hover:bg-slate-400",
                      ].join(" ")}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
